import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { useI18n } from "@/context/I18nContext";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="max-w-2xl mx-auto px-4 py-32 text-center">
      <SEO title="404 — Page not found" description="The page you're looking for doesn't exist." />
      <div className="text-8xl font-semibold text-blue-600 dark:text-blue-400 tracking-tight">404</div>
      <h1 className="mt-4 text-2xl sm:text-3xl font-semibold text-slate-900 dark:text-white">{t("404.title")}</h1>
      <p className="mt-3 text-slate-500 dark:text-slate-400">{t("404.subtitle")}</p>
      <div className="mt-8 flex items-center justify-center gap-3">
        <Link to="/" className="px-6 py-3 rounded-full bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium">{t("404.home")}</Link>
        <Link to="/tools" className="px-6 py-3 rounded-full border border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-white/5 text-sm font-medium">{t("404.tools")}</Link>
      </div>
    </div>
  );
}
